import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { PreviewState } from "@/services/preview/types";

export const getters: GetterTree<PreviewState, RootState> = {
    getPreviewControlsStatus(state): boolean {
        return state.previewControlsStatus;
    }
};
